import { NgModule } from '@angular/core';
import { HisCommunicationlogSharedModule } from './communicationlog-shared.module';

/**
 * CoreModule for Communicationlog.
 */
@NgModule( {
    imports: [
        HisCommunicationlogSharedModule
    ],
    declarations: [
    ],
    exports: [
        HisCommunicationlogSharedModule
    ]
} )

export class HisCommunicationlogCoreModule {
}
